import * as React from "react";
import {cx} from "emotion";

import "./main-panel.scss";

import {cs}        from "@Common/react/chain-services";
import {fragments} from "@Common/react/fragments";
import {keyed}     from "@Common/react/keyed";
import {chain}     from "@Common/utils/fs";

import {multiplySize}   from "../common/multiply-size";
import {subtractVector} from "../common/subtract-vector";
import {toCssPos}       from "../common/to-css-pos";
import {PreviewCanvas}  from "../preview-canvas/preview-canvas";

import {calFrameLoc}   from "./cal-frame-loc";
import {CanvasDesktop} from "./canvas-desktop";

export const MainPanel = (
    {
        objs,
        className=undefined,
        renderOverlay,
        vpSize,
        mobile,
        frame,
    }
) => cs(
    ["canvasDesktop", (_, next) => CanvasDesktop({
        className: cx("main-panel-45i", className),
        next,
    })],
    ({}, next) => (
        !vpSize ? (
            <div className="loading">
                Loading...
            </div>
        ) : (
            next()
        )
    ),

    ["frameLoc", ({canvasDesktop}, next) => next(calFrameLoc({
        desktopSize: canvasDesktop.size,
        vpSize,
        mobile,
        frame,
    }))],

    ({frameLoc, canvasDesktop}, next) => fragments(
        next(),
        renderOverlay({
            frame: frameLoc,
            vpSize,
            desktop: {
                getBoundingClientRect: canvasDesktop.getBoundingClientRect,
            },
        }),
    ),
    ({frameLoc}, next) => <>
        <div {...{
            className: "frame",
            style: {
                ...chain(
                    frameLoc.center,
                    (_) => subtractVector(_, {x: vpSize.width/2, y: vpSize.height/2}),
                    toCssPos,
                ),
                // ...frameLoc.size,
                ...vpSize,
                transform: `scale(${frameLoc.size.width / vpSize.width})`,
            },
        }}>
            {next()}
        </div>
    </>,
    () => PreviewCanvas({
        className: null,
        objs,
        size: vpSize,
        ratio: 1 / Math.round(vpSize.width / Math.min(600, vpSize.width)),
        // size: multiplySize(vpSize, 1 / Math.round(vpSize.width / Math.min(800, vpSize.width))),
        vpSize,
    }),
);

